import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { APIResponse } from '../variables/api-response';
import { CompanyDataModel } from '../variables/common';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  baseUrl: string;

  constructor(private http: HttpClient,
    private commonService: CommonService) {
    this.baseUrl = environment.API_URL;
  }


  getAllCompany() {
    return this.http.get<APIResponse>(this.baseUrl + 'api/company');
  }


  getCurrentCompany() {
    return this.http.get<APIResponse>(this.baseUrl + 'api/company/' + this.commonService.currentCompany$);
  }


  getLogo(fileName: string) {
    return this.http.get(this.baseUrl + 'api/company/logo/' + fileName);
  }

  uploadPdfFile(fileName: string, obj: FormData) {
    return this.http.post(this.baseUrl + 'api/company/upload/' + fileName, obj);
  }

  updateCompany(company: CompanyDataModel) {
    return this.http.post<APIResponse>(this.baseUrl + 'api/company/' + this.commonService.currentCompany$, company);
  }

  getValidInvalidCertificatesDetails(payload: any) {
    return this.http.post<APIResponse>(this.baseUrl + 'api/reports/get-valid-invalid-certificates-details', payload);
  }

  // graph apis
  getInvalidCertificatesStateWiseGraphData(company: any) {
    return this.http.post<APIResponse>(this.baseUrl + 'api/reports/get-valid-invalid-certificates-state-wise-graph-data', company);
  }

  getInvalidCertificatesFormWiseGraphData(company: any) {
    return this.http.post<APIResponse>(this.baseUrl + 'api/reports/get-valid-invalid-certificates-form-wise-graph-data', company);
  }
}

